(function(){"use strict";function fire(el,type){el.dispatchEvent(new Event(type,{bubbles:!0}))}var sel=document.getElementById("variantSel"),vbtns=Array.prototype.slice.call(document.querySelectorAll("[data-jr-variant]"));function syncVariant(){sel&&vbtns.forEach(function(b){b.setAttribute("aria-pressed",String(b.getAttribute("data-jr-variant")===sel.value))})}vbtns.forEach(function(b){b.addEventListener("click",function(){if(!(!sel||b.disabled)){sel.value=b.getAttribute("data-jr-variant"),fire(sel,"change");var m=b.textContent.match(/(\d+(?:\.\d+)?)\s*GPM/i),gpm=document.getElementById("jsGpm");m&&gpm&&gpm.tagName==="SELECT"&&Array.prototype.some.call(gpm.options,function(o){return o.value===m[1]})&&(gpm.value=m[1],fire(gpm,"input"),fire(gpm,"change"))}})}),sel&&sel.addEventListener("change",syncVariant);var gsel=document.getElementById("jsGpm"),gbtns=Array.prototype.slice.call(document.querySelectorAll("[data-jr-gpm]"));function syncGpm(){gsel&&gbtns.forEach(function(b){b.setAttribute("aria-pressed",String(b.getAttribute("data-jr-gpm")===gsel.value))})}gbtns.forEach(function(b){b.addEventListener("click",function(){if(gsel){var v=b.getAttribute("data-jr-gpm");gsel.value=gsel.value===v?"":v,fire(gsel,"input"),fire(gsel,"change"),syncGpm()}})}),gsel&&(gsel.addEventListener("change",syncGpm),gsel.addEventListener("input",syncGpm));
// Buy it now uses the same add result and checkout validation as the cart.
var add = document.getElementById('pdpAdd');
var now = document.getElementById('jrBuyNow');
var waiting = false;
if (add && now) {
  var buyLabel = now.textContent;
  function syncNow() {
    if (typeof window.JPS_syncPurchaseState === 'function') window.JPS_syncPurchaseState();
    var tx = window.JPSCartTransactions;
    var busy = tx && tx.state && tx.state().busy;
    now.disabled = add.disabled || busy || add.dataset.cartPending === 'true' || add.dataset.cartUncertain === 'true';
    now.textContent = add.dataset.cartPending === 'true' ? buyLabel + '…' : add.disabled ? add.textContent : buyLabel;
    now.setAttribute('aria-busy', add.dataset.cartPending === 'true' ? 'true' : 'false');
  }
  now.addEventListener('click', function () {
    syncNow();
    if (now.disabled || waiting) return;
    waiting = true;
    add.click();
    if (add.dataset.cartPending !== 'true') waiting = false;
  });
  document.addEventListener('jps:purchase-state', function () {
    if (waiting && add.dataset.cartPending !== 'true') {
      waiting = false;
      if (add.dataset.lastAddStatus === 'added' && add.dataset.cartUncertain !== 'true') {
        var setup = window.JPSCartSetup;
        if (setup && typeof setup.continueToCheckout === 'function') setup.continueToCheckout();
        else {
          // A missing guard may never fall through to an unvalidated checkout.
          var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
          location.assign(root + 'cart');
        }
      }
    }
    syncNow();
  });
  document.addEventListener('jps:cart:transaction', syncNow);
  document.addEventListener('DOMContentLoaded', syncNow);
  window.addEventListener('pageshow', function () { Promise.resolve().then(syncNow); });
  if (sel) sel.addEventListener('change', syncNow);
  syncNow();
}
syncVariant();
syncGpm();
})();
